module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSubgrupo
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), _c('select-subgrupo', {
    attrs: {
      "show-text-danger-subgrupo": _vm.showTextDangerSubgrupo,
      "nomeSubgrupo": _vm.dados.subgrupo.nome
    },
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimite
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimite
    }
  }, [_vm._v("Limite Financeiro (R$)")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.dados.limite.valor),
      callback: function($$v) {
        _vm.$set(_vm.dados.limite, "valor", $$v)
      },
      expression: "dados.limite.valor"
    }
  }, 'money', _vm.money, false))], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo Subgrupo do Contrato")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-463b9927"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/distribuicoes/contratos/contratoSubgrupoForm.vue
// module id = 839
// module chunks = 0